import {Option, Product, Productmeda} from "./product";
import Server from "../server";
import {sizeRe} from "../shop/product";

export interface Extra extends Option {
    image: string | undefined,
}

function pm(url: string) : Productmeda {
    return {
        mainMedia: {
            image: {
                url: url
            }
        }
    }
}

export async function getExtrasAvailable() : Promise<Extra[]> {

    const gifts = await Server.instance().products("add-on-gifts");
    const extras = gifts
        .map(g => productToExtra(g))
        .filter(x => x.choices && x.choices.length > 0);

    return extras;
}

function productToExtra(product: Product) {

    const sizeOption = getSizeOption(product) as Option;

    const extra = {
        name: product.name,
        image: product.media?.mainMedia?.thumbnail?.url || product.media?.mainMedia?.image?.url,
        choices: sizeOption.choices ? sizeOption.choices.filter(x => x.visible) : undefined
    }
    return extra;
}

export function getSizeOption(product: Product) : Option | undefined {
    if (product.productOptions) {
        const opts = product.productOptions.filter(x => x.name?.match(sizeRe));
        return opts[0];
    }
    return undefined;
}
